import React, { useState, useRef } from "react";
import { Link, useNavigate } from 'react-router-dom';
import ApplyModal from './ApplyModal';
import './ApplyModal.css';

function Header({ schoolId = null }) {
  const baseUrl = schoolId ? `/${schoolId}` : '';
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  // ✅ store WHICH dropdown is open
  const [openDropdown, setOpenDropdown] = useState(null);
  const navbarRef = useRef(null);
  const togglerRef = useRef(null);
  /* ✅ CLOSE NAVBAR (BOOTSTRAP-SAFE) */
  const closeMobileMenu = () => {
    setOpenDropdown(null);

    if (window.innerWidth < 992 && togglerRef.current) {
      togglerRef.current.click(); // 🔥 closes collapse properly
    }
  };
  const toggleDropdown = (name) => {
    setOpenDropdown(prev => (prev === name ? null : name));
  };

  const navigateToSection = (e, path, sectionId) => {
    e.preventDefault();
    e.stopPropagation();

    navigate(`${baseUrl}${path}`, {
      state: { scrollTo: sectionId }
    });

    closeMobileMenu();
  };

  const goToAboutUsSection = (e, sectionId) => {
    e.preventDefault();              // ⛔ stop Link default
    e.stopPropagation();             // ⛔ stop dropdown toggle

    navigate(`${baseUrl}/about`, {
      state: { scrollTo: sectionId }
    });

    closeMobileMenu();
  };

  const goToAcademicsSection = (e, sectionId) => {
    e.preventDefault();              // ⛔ stop Link default
    e.stopPropagation();             // ⛔ stop dropdown toggle

    navigate(`${baseUrl}/academics`, {
      state: { scrollTo: sectionId }
    });

    closeMobileMenu();
  };

  const goToAdmissionsSection = (e, sectionId) => {
    e.preventDefault();              // ⛔ stop Link default
    e.stopPropagation();             // ⛔ stop dropdown toggle

    navigate(`${baseUrl}/admissions`, {
      state: { scrollTo: sectionId }
    });

    closeMobileMenu();
  };

  const goToLifeAtTIGPSSection = (e, sectionId) => {
    e.preventDefault();              // ⛔ stop Link default
    e.stopPropagation();             // ⛔ stop dropdown toggle

    navigate(`${baseUrl}/life-at-tigps`, {
      state: { scrollTo: sectionId }
    });

    closeMobileMenu();
  };

  const goToContactSection = (e, sectionId) => {
    e.preventDefault();              // ⛔ stop Link default
    e.stopPropagation();             // ⛔ stop dropdown toggle

    navigate(`${baseUrl}/contact`, {
      state: { scrollTo: sectionId }
    });

    closeMobileMenu();
  };

  return (
    <header>
      <nav className="navbar navbar-expand-lg">
        <div className="container-fluid">
          <Link className="navbar-brand" to={baseUrl || "/"} onClick={closeMobileMenu}>
            <img src="/pictures/tigps_logo.png" alt="TIGPS Logo" className="logo-img" />
          </Link>
          <button ref={togglerRef} className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav mx-auto" style={{ marginRight: '10px' }}>
              <li className="nav-item">
                <Link className="nav-link" to={baseUrl || "/"} onClick={closeMobileMenu}>Home</Link>
              </li>

              {/* -------------- About us Menu --------------- */}

              <li
                className={`nav-item dropdown ${openDropdown === 'about' ? 'open' : ''}`}
                onClick={() => toggleDropdown('about')}
              >
                <Link to={`${baseUrl}/about`} className="nav-link dropdown-toggle">About Us</Link>
                <ul className="dropdown-menu-custom">
                  <li>
                    <Link to={`${baseUrl}/about`} onClick={(e) => goToAboutUsSection(e, "about-us")} className="dropdown-item-custom">
                      Who We Are
                    </Link>
                  </li>
                  <li>
                    <Link to={`${baseUrl}/about`} onClick={(e) => goToAboutUsSection(e, "affiliations-and-certifications")} className="dropdown-item-custom">
                      Affiliations and Certifications
                    </Link>
                  </li>
                  <li>
                    <Link to={`${baseUrl}/about`} onClick={(e) => goToAboutUsSection(e, "accolades-and-awards")} className="dropdown-item-custom">
                      Accolades & Awards
                    </Link>
                  </li>
                  <li>
                    <Link to={`${baseUrl}/about`} onClick={(e) => goToAboutUsSection(e, "our-programs-towards-the-society")} className="dropdown-item-custom">
                      Our Programs towards the Society
                    </Link>
                  </li>
                  <li>
                    <Link to={`${baseUrl}/about`} onClick={(e) => goToAboutUsSection(e, "mentorship")} className="dropdown-item-custom">
                      Mentorship
                    </Link>
                  </li>
                </ul>
              </li>

              {/* -------------- Academics Menu --------------- */}

              <li
                className={`nav-item dropdown ${openDropdown === 'academics' ? 'open' : ''}`}
                onClick={() => toggleDropdown('academics')}
              >
                <Link to={`${baseUrl}/academics`} className="nav-link dropdown-toggle">Academics</Link>
                <ul className="dropdown-menu-custom">
                  <li>
                    <Link to={`${baseUrl}/academics`} onClick={(e) => goToAcademicsSection(e, "pre-primary-program")} className="dropdown-item-custom">
                      Pre primary programme
                    </Link>
                  </li>
                  <li>
                    <Link to={`${baseUrl}/academics`} onClick={(e) => goToAcademicsSection(e, "primary-program")} className="dropdown-item-custom">
                      Primary programme
                    </Link>
                  </li>
                  <li>
                    <Link to={`${baseUrl}/academics`} onClick={(e) => goToAcademicsSection(e, "senior-section")} className="dropdown-item-custom">
                      Senior Section
                    </Link>
                  </li>
                  <li>
                    <Link to={`${baseUrl}/academics`} onClick={(e) => goToAcademicsSection(e, "senior-secondary-program")} className="dropdown-item-custom">
                      Senior Secondary programme
                    </Link>
                  </li>
                  <li>
                    <Link to={`${baseUrl}/academics`} onClick={(e) => goToAcademicsSection(e, "question-bank")} className="dropdown-item-custom">
                      Question Bank
                    </Link>
                  </li>
                  <li>
                    <Link to={`${baseUrl}/academics`} onClick={(e) => goToAcademicsSection(e, "techno-aep")} className="dropdown-item-custom">
                      Techno AEP
                    </Link>
                  </li>
                </ul>
              </li>

              {/* -------------- Admission Menu --------------- */}
              <li
                className={`nav-item dropdown ${openDropdown === 'admissions' ? 'open' : ''}`}
                onClick={() => toggleDropdown('admissions')}
              >
                <Link to={`${baseUrl}/admissions`} className="nav-link dropdown-toggle">Admissions</Link>
                <ul className="dropdown-menu-custom">
                  <li>
                    <Link onClick={(e) => goToAdmissionsSection(e, "criteria")} className="dropdown-item-custom">
                      Criteria
                    </Link>
                  </li>
                  <li>
                    <Link onClick={(e) => goToAdmissionsSection(e, "admission-application-procedurer")} className="dropdown-item-custom">
                      Admission Procedure
                    </Link>
                  </li>
                </ul>
              </li>

              {/* -------------- Life at tigps Menu --------------- */}

              <li
                className={`nav-item dropdown ${openDropdown === 'life' ? 'open' : ''}`}
                onClick={() => toggleDropdown('life')}
              >
                <Link to={`${baseUrl}/life-at-tigps`} className="nav-link dropdown-toggle">Life at TIGPS</Link>
                <ul className="dropdown-menu-custom">
                  <li>
                    <Link onClick={(e) => goToLifeAtTIGPSSection(e, "beyond-academics")} className="dropdown-item-custom">
                      Beyond Academics
                    </Link>
                  </li>
                  <li>
                    <Link onClick={(e) => goToLifeAtTIGPSSection(e, "gallery")} className="dropdown-item-custom">
                      Gallery
                    </Link>
                  </li>
                  <li>
                    <Link onClick={(e) => goToLifeAtTIGPSSection(e, "news-updates")} className="dropdown-item-custom">
                      News & Updates
                    </Link>
                  </li>
                  <li>
                    <Link onClick={(e) => goToLifeAtTIGPSSection(e, "celebratory-events")} className="dropdown-item-custom">
                      Celebratory Events
                    </Link>
                  </li>
                </ul>

              </li>

              {/* -------------- Contact us Menu --------------- */}


              <li className="nav-item">
                <Link className="nav-link" to={`${baseUrl}/contact`} onClick={closeMobileMenu}>Contact Us</Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link" to={"https://careers.tigps.in/"} onClick={closeMobileMenu} target="_blank">Career</Link>
              </li>
            </ul>
            <div className="apply-btn-wrapper">
              <button className="btn apply-btn" onClick={() => setIsModalOpen(true)}>Apply Now</button>
            </div>
          </div>
        </div>
      </nav>
      <ApplyModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </header>
  );
}

export default Header;